/**
 * @file        src/lib/units/power.ts
 * @description The single kW↔hp power-unit conversion for JCK AUTO. Collapses five per-file copies of
 *              KW_TO_HP into one declaration and one set of functions. Unrounded functions feed the
 *              pricing path; the *ForDisplay functions round and are for input fields and labels only.
 * @rule        The decree mandates the exact ratio 1 кВт = 1,35962 л.с. and forbids rounding down
 *              («округление в меньшую сторону не допускается»). The pricing path MUST use the UNROUNDED
 *              functions (kwToHp / hpToKw). The *ForDisplay functions MUST NEVER reach a fee
 *              calculation: rounding 117,69–118,04 kW down to 160 hp grants the preferential rate and
 *              turns a 3 456 000 ₽ fee into 5 200 ₽ (undercharge of 3 450 800 ₽).
 * @universal   knowledge/universals/tools.md#power-unit-conversion-kwhp
 */

/** Exact ratio mandated by ПП РФ №1291 (в ред. ПП 1713): 1 кВт = 1,35962 л.с. THE ONLY declaration. */
export const KW_TO_HP = 1.35962;

/** kW → hp, UNROUNDED. Use in the pricing path (the value that reaches findBracket / the fee). */
export function kwToHp(kw: number): number {
  return kw * KW_TO_HP;
}

/** hp → kW, UNROUNDED. Use in the pricing path. */
export function hpToKw(hp: number): number {
  return hp / KW_TO_HP;
}

/** kW → hp, ROUNDED to whole hp. Display only (input fields, labels) — never a fee input. */
export function kwToHpForDisplay(kw: number): number {
  return Math.round(kw * KW_TO_HP);
}

/** hp → kW, ROUNDED to whole kW. Display only (input fields, labels) — never a fee input. */
export function hpToKwForDisplay(hp: number): number {
  return Math.round(hp / KW_TO_HP);
}
